import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'
import { Breadcrumbs } from '../components/shared/Breadcrumbs'
import SiteRecoveryCalc from '../components/calculators/SiteRecoveryCalc'

export default function SiteRecoveryPage() {
  return (
    <>
      <Helmet>
        <title>Azure Site Recovery Cost Calculator UK | AzureCalc.uk</title>
        <meta name="description" content="Estimate the full Azure Site Recovery cost for UK South in GBP. Per-instance fees, replica storage, replication transfer, and failover test compute — all four components together. The instance fee is typically only 25% of the real DR bill." />
        <link rel="canonical" href="https://www.azure-calc.co.uk/site-recovery" />
        <meta property="og:title" content="Azure Site Recovery Cost Calculator UK" />
        <meta property="og:description" content="ASR pricing in GBP: instance fees + replica storage + replication transfer + failover compute. Most teams underestimate by 3–4×." />
        <meta property="og:url" content="https://www.azure-calc.co.uk/site-recovery" />
        <meta property="og:image" content="https://www.azure-calc.co.uk/og/azure-calc-og.png" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <script type="application/ld+json">{JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebApplication',
          name: 'Azure Site Recovery Cost Calculator',
          description: 'Estimate the full Azure Site Recovery cost including instance fees, replica storage, replication transfer, and failover test compute for UK South.',
          url: 'https://www.azure-calc.co.uk/site-recovery',
          applicationCategory: 'FinanceApplication',
          operatingSystem: 'Web',
          offers: { '@type': 'Offer', price: '0', priceCurrency: 'GBP' },
        })}</script>
      </Helmet>

      <div className="px-6 py-6 w-full">
        <div className="pb-6 mb-8" style={{ borderBottom: '1px solid var(--outline-variant)' }}>
          <Breadcrumbs />
          <h1 className="text-2xl font-bold mb-2" style={{ color: 'var(--text-primary)' }}>
            Azure Site Recovery Cost Calculator
          </h1>
          <p className="text-sm" style={{ color: 'var(--text-tertiary)' }}>
            UK South pricing · Per-instance fees · Replica storage · Replication transfer · Failover compute
          </p>
        </div>

        <SiteRecoveryCalc />

        <div className="mt-12 pt-8" style={{ borderTop: '1px solid var(--outline-variant)' }}>
          <h2 className="text-[13px] font-bold uppercase tracking-widest mb-4" style={{ color: 'var(--text-tertiary)' }}>
            Related guides
          </h2>
          <Link
            to="/guides/azure-site-recovery-pricing-uk"
            className="flex items-center gap-3 p-4 rounded transition-colors group"
            style={{ backgroundColor: 'var(--surface-container)', border: '1px solid var(--outline-variant)' }}
          >
            <span className="material-symbols-outlined text-[#0078d4] text-[20px]" style={{ fontVariationSettings: "'FILL' 1" }}>menu_book</span>
            <div>
              <p className="text-[14px] font-semibold" style={{ color: 'var(--text-secondary)' }}>Azure Site Recovery Pricing Guide UK 2026</p>
              <p className="text-[12px]" style={{ color: 'var(--text-tertiary)' }}>Why the per-instance fee is only the start — the four components of your real DR bill</p>
            </div>
            <span className="material-symbols-outlined text-[#0078d4] text-[16px] ml-auto">arrow_forward</span>
          </Link>
        </div>
      </div>
    </>
  )
}
